import React from 'react';
import Helmet from 'react-helmet'
import Layout from './_newsroomLayout';
import content from 'locale/about/is/newsroom.yml';

export default (props) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>
          Skákgreind | Fréttir
        </title>
      </Helmet>
      <Layout content={content} {...props}/>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/pages/about/newsroom/index.is.js